export default __webpack_public_path__ + "static/media/card-level-icon.cc31ed90.svg";